<template>
        <img :src="pathToImage" alt="">
</template>

<script>
export default {
    props: {
        identifier: {
            required: true
        }
    },
    computed: {
        pathToImage() {
            return `/api/qrcode/${this.identifier}/image`
        }
    },
    data() {
        return {
            image: null
        }
    },
}
</script>

<style scoped>

</style>
